"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarning = exports.resetWarnings = void 0;
const react_1 = __importDefault(require("react"));
let warnings = {};
const resetWarnings = () => {
    warnings = {};
};
exports.resetWarnings = resetWarnings;
const useWarning = () => {
    return react_1.default.useMemo(() => {
        const warn = (warning) => {
            if (!warnings[warning] && process.env.NODE_ENV !== "production") {
                warnings[warning] = true;
                // eslint-disable-next-line no-console
                console.warn(warning);
            }
        };
        return {
            warn,
            warnDeprecation: warn
        };
    }, []);
};
exports.useWarning = useWarning;
//# sourceMappingURL=useWarning.js.map